module.exports = __webpack_public_path__ + "assets/img/KRUG_BRASIL__0770-min.4302f1a8.jpg";